<script setup>
import { DEV_MODE } from '@/config/dev-mode';
import { useAnalysisStore } from '@/store/modules/analysis';
import { addContentLogAPI } from '@/api/logServiceApi';
import { calculateDDay } from '@/utils/dateFormatter';
/* icon */
import IconArrow08 from '@/components/svg/IconArrow08.vue';

const analysisStore = useAnalysisStore();

const props = defineProps({
  ticketCountData: {
    required: true,
  },
  personalityLogData: {
    required: true,
  },
  hasPermission: {
    required: true,
  },
  loadingTicket: {
    required: true,
  },
});

const emit = defineEmits(['goPopAnalysis']);

const personalityLogData = computed(() => {
  if (!props.personalityLogData?.length) return null;
  const personalityData = props.personalityLogData[0];
  return personalityData;
});

const dDay = computed(() => calculateDDay(personalityLogData.value?.expiryDate));

/** 목차 리스트 */
const personalityContentList = [
  {
    label: '📖 성향분석 안내서 - 당신의 성향을 이해하는 다섯가지 시선',
    view: '/personality/guide',
  },
  {
    label: '1. 사주명리의 시선으로 바라 본, 나를 구성하는 오행의 기운 흐름',
    view: '/personality/content',
  },
  { label: '2. 명리체계로 분석한 낭만만세력의 성향 종합 분석', view: '/personality/content' },
  { label: '3. 나를 이루는 다섯 가지 오행 기운의 구성은?', view: '/personality/content' },
  { label: '4. 음과 양의 구성으로 본 나의 성향은?', view: '/personality/content' },
  { label: '5. 나의 성향이 향하는 방향', view: '/personality/content' },
  { label: '6. 정보수집의 관점에서 보는 나의 스타일은?', view: '/personality/content' },
  { label: '7. 나의 판단 스타일!', view: '/personality/content' },
  { label: '8. 나의 관계 스타일!', view: '/personality/content' },
  { label: '9. 나를 발전 시키는 방향은!', view: '/personality/content' },
  { label: '10. 나에게 에너지를 플러스 해주는 기운은?', view: '/personality/content' },
  {
    label: '11. 성향과 조화로운 우선 추천 진로, 어떤 진로가 잘 맞을까요?',
    view: '/personality/content',
  },
];

const goPopAnalysis = () => emit('goPopAnalysis');

/** 목차 이동 */
const goToChildMenu = (contentIdx) => {
  addContentLogAPI({
    contentType: props.hasPermission ? 'ap_personality_toc_paid_opt3' : 'ap_personality_toc_free_opt3',
    option3: String(contentIdx),
  });

  if (contentIdx > 1 && !props.hasPermission) {
    goPopAnalysis();
    return;
  }
  analysisStore.navigateToContent('/personality', contentIdx);
  DEV_MODE && console.log('목차 이동', contentIdx);
};
</script>

<template>
  <div class="si-overview si-overview--personality">
    <div class="si-overview__cover">
      <div class="si-overview__cover-inner">
        <div class="si-overview__header">
          <div class="si-overview__title">
            <div class="si-overview__name">
              <span class="si-overview__name-text">{{ analysisStore.userName || '-' }}</span
              ><span class="si-overview__name-suffix">님의</span>
            </div>
            <div class="si-overview__service">낭만 성향분석</div>
          </div>
          <div class="si-overview__badge">
            <template v-if="!loadingTicket && hasPermission">
              <span class="si-overview__badge-tag" v-if="personalityLogData?.expiryDate">
                {{ dDay }}
              </span>
              <span class="si-overview__badge-tag" v-else>소장용</span>
              <span class="si-overview__badge-date" v-if="personalityLogData?.expiryDate">
                ~ {{ personalityLogData?.expiryDate }} 까지
              </span>
            </template>

            <template v-if="!loadingTicket && !hasPermission">
              <span class="si-overview__badge-tag">구매 후 이용가능</span>
            </template>
          </div>
        </div>

        <div class="si-overview__img">
          <img src="@manseImages/tendency_left_img.png" alt="tendency-left-img" />
        </div>
      </div>
    </div>
    <div class="si-overview__toc">
      <div class="si-overview__toc-title">목차</div>
      <div class="si-overview__toc-list">
        <button
          v-for="(item, idx) in personalityContentList"
          :key="idx"
          class="si-overview__toc-item"
          :class="{ 'si-overview__toc-item--locked': !hasPermission }"
          @click="goToChildMenu(idx)"
        >
          {{ item.label }}
          <div class="si-overview__toc-icon">
            <IconArrow08 />
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import '@/assets/nangman_style/_saju-insight-overview.scss';
</style>
